
export class IconsUI {
  constructor() {
  }
}
